// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingStyle_loading__3PmIK","centerPosition":"LoadingStyle_centerPosition__2EsEy"};